import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewContainerRef } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { v4 as uuid4 } from "uuid";
import { environment } from '../../../../../environments/environment';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { TokenStorage } from '../../../../storages/token.storage';
import { OtherKpModel } from '../../models/other-kp-model';
import { OtherKpDetailService } from '../../services/other-kp-detail.service';
import { Nomenclature } from '../../models/nomenclature';
import { ModalOtherKpHistoryChangeComponent } from './modal-history-change/modal-history-change.component';
import { ModalOtherKpMailSenderComponent } from './modal-mail-sender/modal-mail-sender.component';
import { ModalOtherKpSendAdjustmentComponent } from './modal-other-kp-send-adjustment/modal-other-kp-send-adjustment.component';
import { BusOtherKpFilterService } from '../../services/bus-other-kp-filter.service';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
const MODULE_PATH = "TakomaClient.app.modules.other-kp.component.other-kp-detail";

declare var $: any;


@Component({
  selector: 'app-other-kp-modal-detail',
  templateUrl: './other-kp-modal-detail.component.html',
  styleUrls: ['./other-kp-modal-detail.component.scss'],
})
export class OtherKpMainModalDetailComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];
  popupHtmlContent: any = { value: "" }
  errorHtmlContent: any = { value: "" }

  _type: number;
  columnsOtherKp: any[];

  kams: any[] = []
  dbs: any[] = []
  customers: any[] = []
  regions: any[] = []
  types: any[] = []

  otherKp: OtherKpModel = new OtherKpModel();
  dtOptionsOtherKps: DataTables.Settings = {};
  dataSetOtherKp: any;
  http: HttpClient;
  mailPopover = new Array<string>();
  detailDistributionFirst: string;
  detailDistributionSecond: string;
  spinner: NgxSpinnerService;
  token: TokenStorage;
  isChiefRole;
  isContainCd = false;
  isContainFm = false;
  rejected = false;
  isContainSai = false

  hideOutFromDevelopFilter = false

  pageSize = 100
  currentpage = 1
  first

  isSavedReplaceCompetitors: boolean = false;
  private detailOpened = false;

  constructor(private service: OtherKpDetailService,
    protected bus: BusOtherKpFilterService,
    protected toastr: ToastsManager,
    protected vcr: ViewContainerRef,
    protected _http: HttpClient,
    protected _spinner: NgxSpinnerService,
    protected _token: TokenStorage,
    protected _loggingService: LoggingService) {

    this.toastr.setRootViewContainerRef(vcr)
    this.http = _http
    this.spinner = _spinner
    this.token = _token
  }

  ngAfterViewInit(): void {
    setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);
    setTimeout(function () { $('#tableAuction').dataTable(); }, 2000);
  }

  defaultInit() {
    this.updateStateMailIcon()
    this._type = null

    this.isContainCd = false;
    this.isContainFm = false;
    this.rejected = false;

    this.isChiefRole = this.token.isChiefRole()
  }

  ngOnInit() {
    const that = this;

    $('#modalOtherKpDetail').off('show.bs.modal shown.bs.modal hidden.bs.modal')
      .on('show.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1030);
      })
      .on('shown.bs.modal', function () {
        $('#modalOtherKpDetail').css('z-index', 1060);
        $('.modal-backdrop:last').css('z-index', 1055);

        if (!that.detailOpened) {
          that.detailOpened = true;

          that.http.post<DataTablesResponse>(`${apiServer}/otherKp/typesList`, {}, {}).subscribe(types => {
            that.types = types.data
            that.otherKp.typeName = that.findTypeName(that.otherKp.typeId);
          });

          that.http.post<DataTablesResponse>(`${apiServer}/otherKp/regionsList`, {}, {}).subscribe(async regions => {
            that.regions = regions.data
            await that.updateLocalLists();
          });
        }
      })
      .on('hidden.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1041);
      });

    that.errorHtmlContent.value = '';
    setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);
    that.checkTemplates()
    that.columnsOtherKp = this.getColumns();

    that.dtOptionsOtherKps = {
      pagingType: 'full_numbers',
      pageLength: 100,
      autoWidth: true,
      dom: 'tip',
      info: false,
    };

    setTimeout(function () { $('#tableAuction').dataTable(); }, 2000);

    that.subs.push(that.service.otherKp$.subscribe(async otherKp => {
      that.otherKp = otherKp;

      if (that.service.auctionMode && that.otherKp) {
        that.otherKp.iSReplaceCompetitors = 1;
      }
      if (that.otherKp.customerName && that.otherKp.customerName.includes(' - ')) {
        const sep = ' - ';
        const idx = that.otherKp.customerName.indexOf(sep);
        that.otherKp.inn = that.otherKp.customerName.substring(0, idx);
        that.otherKp.customerName = that.otherKp.customerName.substring(idx + sep.length);
      }
      that.otherKp.typeName = that.findTypeName(that.otherKp.typeId);
      that.checkTemplates()
      that.updateStateMailIcon();
      that.errorHtmlContent.value = ''

      that.columnsOtherKp = that.getColumns();

      setTimeout(function () {
        $('#tableAuction').dataTable();
        that.updateLocalLists()
        that.service.triggerReloadNomenclature()
      }, 2000);

      setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);

      const waitForLists = that.service.isOpeningKp;
      if (waitForLists && that._spinner) { that._spinner.show(); }
      try {
        await that.updateLocalLists();
      } finally {
        if (waitForLists && that._spinner) { that._spinner.hide(); that.service.isOpeningKp = false; }
      }

      if (!that.service.noNeedUpdateNewCustomerName) {
        if (that.otherKp.inn != null) {
          that.service.newCustomerInn = that.otherKp.inn
          that.service.newCustomerName = that.otherKp.customerName
        } else {
          that.service.newCustomerInn = ""
          that.service.newCustomerName = ""
        }
      } else {
        that.service.noNeedUpdateNewCustomerName = false
      }
    }));

    this.subs.push(that.service.triggerSaveObserver$.subscribe(() => {
      that.onSave()
    }));

    this.subs.push(that.service.triggerReloadTemplateObserver$.subscribe(() => {
      that.checkTemplates()
    }));

  }


  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  /*
   * @deprecated Удалится после перехода на статические колонки.
   */
  private getColumns(): any[] {
    return [
      { field: 'numberOfRow', header: '№', width: 40, title: 'Порядковый номер строки' },
      { field: 'status', header: 'Статус', width: 140, title: 'Статус согласования' },
      { field: 'name', header: 'Номенклатура', width: 350, title: 'Наименование Солофарм' },
      this.isReplaceCompetitorsView
        ? { field: 'nmc', header: 'ЦК', width: 80, title: 'ЦК' }
        : { field: 'nmc', header: 'НМЦ', width: 80, title: 'НМЦ' },
      { field: 'count', header: 'Кол-во', width: 80, title: 'Кол-во в упаковках СолоФарм' },
      { field: 'priceKp', header: 'Цена КП', width: 125, title: 'Цена коммерческого предложения' },
      { field: 'summKp', header: 'Сумма КП', width: 125, title: 'Сумма коммерческого предложения' },
      { field: 'pl', header: 'ПЛ', width: 95, title: 'Стандартная цена прайс-листа СолоФарм' },
      { field: 'sp', header: 'СП', width: 95, title: 'Специальная цена прайс-листа СолоФарм' },
      { field: 'gr', header: 'ГР', width: 95, title: 'Цена госреестра в руб. без НДС' },
      { field: 'marge', header: 'Марж-ть, %', width: 95, title: 'Марж-ть, %' },
    ];
  }

  selectDistibutor(value, row) {
    let distributorId = this.dbs.find(el => el.name == value)?.distributorId
    this.otherKp.distributorId = distributorId
    this.service.currentOtherKp.distributorId = distributorId
  }

  selectKam(value, row) {
    let kamId = this.kams.find(el => el.name == value).kamId
    this.otherKp.kamId = kamId
    this.service.currentOtherKp.kamId = kamId
  }

  selectCustomer(value, row) {
    let customerId = this.customers.find(el => el.name == value).customerId
    this.otherKp.customerId = customerId
    this.otherKp.customerName = value
    this.service.currentOtherKp.customerId = customerId
    this.service.currentOtherKp.customerName = value
    this.checkTemplates()
  }

  // TODO: Добавить асинхронный декоратор для логирования.
  // TODO: Добавить асинхронный декоратор для отладки.
  // TODO: Проработать типизацию.
  async onRegionSelect(regionName: string | null): Promise<void> {
    this._spinner.show();

    if (regionName != null) {
      const regionId = this.regions.find(region => region.name == regionName).regionId;

      this.otherKp.regionId = regionId;
      this.service.currentOtherKp.regionId = regionId;
    } else {
      this.otherKp.regionId = null;
      this.service.currentOtherKp.regionId = null;
    }

    // TODO: Удалить вместе с методом сервиса.
    this.service.triggerUpdateLists();

    await this.refreshDictionaries();

    this._spinner.hide();
  }

  updateLocalLists(): Promise<void> {
    if (!this.otherKp || !this.otherKp.regionName) {
      this.kams = [];

      return Promise.resolve();
    }

    const region = this.regions.find(r => r.name === this.otherKp.regionName);
    if (!region) return Promise.resolve();

    return Promise.all([
      this.http.post<DataTablesResponse>(`${apiServer}/otherKp/kamsList`, { regionId: region.regionId, kpId: this.otherKp.id }).toPromise(),
      this.http.post<DataTablesResponse>(`${apiServer}/otherKp/distributorsList`, { regionId: region.regionId }).toPromise(),
      this.http.post<DataTablesResponse>(`${apiServer}/otherKp/customersList`, { regionId: region.regionId }).toPromise()
    ])
      .then(([kams, dbs, customers]) => {
        this.kams = kams.data;
        this.dbs = dbs.data;
        this.customers = [{ name: 'Другое', id: null }].concat(customers.data);
        this.checkTemplates();
      })
      .catch(err => {
        console.error('updateLocalLists failed', err);
        throw err;
      });
  }



  getGoodDetailsHtml(goodDetails: any): string {
    if (!goodDetails) return '';
    return goodDetails.replace(/\r\n|\n/g, '<br/>');
  }

  private async refreshDictionaries(): Promise<void> {
    await this.updateLocalLists();

    // Если KAM только 1 на регион, то он выбирается по умолчанию, в остальных случаях пользователь выбирает сам.
    if (this.kams.length === 1) {
      const defaultKam = this.kams[0];

      this.otherKp.kamId = defaultKam.kamId;
      this.otherKp.kamName = defaultKam.name;
      this.service.currentOtherKp.kamId = defaultKam.kamId;
      this.service.currentOtherKp.kamName = defaultKam.name;
    } else {
      this.otherKp.kamId = null;
      this.otherKp.kamName = null;
      this.service.currentOtherKp.kamId = null;
      this.service.currentOtherKp.kamName = null;
    }

    this.otherKp.distributorId = null
    this.service.currentOtherKp.distributorId = null
    this.otherKp.distributorName = null
    this.service.currentOtherKp.distributorName = null
    this.otherKp.customerId = null
    this.service.currentOtherKp.customerId = null
    this.otherKp.customerName = 'Другое'
    this.service.currentOtherKp.customerName = 'Другое'
  }

  checkTemplates() {
    if (this.otherKp.distributorName != null) {
      $('#db-br').show()
      $('#db-name').show()
    } else {
      $('#db-br').hide()
      $('#db-name').hide()
    }

    if (this.otherKp.customerName != null) {
      $('#customer-br').show()
      $('#customer-name').show()
    } else {
      $('#customer-br').hide()
      $('#customer-name').hide()
    }

    if (this.otherKp.customerName == "Другое") {
      $('#newCustomerInputs').show()
      $('#nomenclatureLabel').css('margin-top', `45px`);

      $('#customer-br').hide()
      $('#customer-name').hide()
    } else {
      $('#newCustomerInputs').hide()
      $('#nomenclatureLabel').css('margin-top', `5px`);
    }

    if (this.service.viewKpNumber != "Новый") {
      $('#bottomBtns').show()
      $('#modulesBtns').show()
    } else {
      $('#bottomBtns').hide()
      $('#modulesBtns').hide()
    }
  }

  onExport(): void {
  }

  mailHistory() {
    this.mailPopover[0] = this.mailPopover[1] = this.mailPopover[2] = "Загрузка истории...";
    if (this.service.currentOtherKp.id != null) {
      this.http.get<Array<string>>(apiServer + "/otherKp/history/" + this.service.currentOtherKp.id)
        .subscribe(resp => {
          this.mailPopover = resp;
        });
    }
  }

  @ViewChild(ModalOtherKpHistoryChangeComponent)
  modalHistory: ModalOtherKpHistoryChangeComponent

  historyChange() {
    if (this.modalHistory != undefined) {
      this.modalHistory.loadHistoryChange(this.otherKp.id);
    }
  }


  onSave(): void {
    const xid = this._loggingService.generateUUID();
    const qualName = `${MODULE_PATH}.OtherKpMainModalDetailComponent.onSave`;
    const inputParams = { otherKpId: this.otherKp?.id ?? null };
    const description = "[EventHandler] Сохранение карточки пользовательского КП";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      const haveErrors = this.haveErrors();
      this.service.isHaveErrors = haveErrors;

      if (!haveErrors) {
        if (this._spinner) { this._spinner.show(); }
        $("button:disabled").attr("title", "");

        const distributorId = this.dbs.find(el => el.name === this.service.currentOtherKp.distributorName)?.distributorId;
        const kamId = this.kams.find(el => el.name === this.service.currentOtherKp.kamName)?.kamId;
        let customerId = this.service.currentOtherKp.customerId
          ?? this.otherKp.customerId
          ?? this.customers.find(el => el.name === this.service.currentOtherKp.customerName)?.customerId;
        const regionId = this.regions.find(el => el.name === this.service.currentOtherKp.regionName)?.regionId;

        this.isSavedReplaceCompetitors = true;

        this.otherKp.iSReplaceCompetitors = this.isAuctionMode() ? 1 : 0;

        if (distributorId) {
          this.otherKp.distributorId = distributorId;
          this.service.currentOtherKp.distributorId = distributorId;
        }

        if (kamId) {
          this.otherKp.kamId = kamId;
          this.service.currentOtherKp.kamId = kamId;
        }

        if (customerId) {
          this.otherKp.customerId = customerId;
          this.service.currentOtherKp.customerId = customerId;
        }

        if (this.otherKp.customerName === 'Другое' || this.isAuctionMode()) {
          this.otherKp.customerId = null;
          this.otherKp.customerName = this.service.newCustomerName;
          this.otherKp.inn = this.service.newCustomerInn;
          this.service.currentOtherKp.customerId = null;
          this.service.currentOtherKp.customerName = this.service.newCustomerName;
          this.service.currentOtherKp.inn = this.service.newCustomerInn;
        }

        if (regionId) {
          this.otherKp.regionId = regionId;
          this.service.currentOtherKp.regionId = regionId;
        }

        const putXid = this._loggingService.generateUUID();
        const putQualName = 'App.Services.OtherKpDetailService.putOtherKp';
        const putDescription = 'Put other KP';

        try {
          this._loggingService.logStart(putXid, putQualName, inputParams, putDescription);

          this.service.putOtherKp(this.otherKp).subscribe({
            next: (result) => {
              this.service.currentOtherKp = result;
              this.service.currentOtherKp.dateAuction = this.otherKp.dateAuction;
              this.service.viewKpNumber = result.id;
              this.service.isNew = false;
              this.service.otherKp.next({ ...this.service.currentOtherKp });

              if (this._spinner) { this._spinner.hide(); }
              this.service.triggerReload();
              this.service.notifyKpSaved();

              this._loggingService.logFinish(putXid, putQualName, inputParams, 'Other KP saved');

              if (!this.isContainFm && !this.isContainCd) {
                if (this.rejected) this.SendAdjustmentMail("rejected");
                else this.SendAdjustmentMail("confirmed");
              }
              this.updateStateMailIcon();

              this._loggingService.logFinish(xid, qualName, inputParams, '[EventHandler] Сохранение карточки пользовательского КП завершено');
            },
            error: (err) => {
              if (this._spinner) { this._spinner.hide(); }
              this._loggingService.logError(putXid, putQualName, err, inputParams, 'Failed to save other KP');
              this._loggingService.logError(xid, qualName, err, inputParams, 'Save other KP failed');
            }
          });
        } catch (error) {
          if (this._spinner) { this._spinner.hide(); }
          this._loggingService.logError(putXid, putQualName, error, inputParams, 'Put other KP method failed');
          this._loggingService.logError(xid, qualName, error, inputParams, 'Save other KP failed');
          throw error;
        }
      } else {
        this._loggingService.logFinish(xid, qualName, inputParams, 'Validation failed - save skipped');
      }
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, 'onSave failed');
      throw error;
    }
  }

  onSaveAndExit(exit: boolean): void {
    const xid = this._loggingService.generateUUID();
    const qualName = `${MODULE_PATH}.OtherKpMainModalDetailComponent.onSaveAndExit`;
    const inputParams = { otherKpId: this.otherKp?.id ?? null, exit };
    const description = "[EventHandler] Сохранение и закрытие карточки пользовательского КП";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      const haveErrors = this.haveErrors();
      this.service.isHaveErrors = haveErrors;

      if (!haveErrors) {
        if (this._spinner) { this._spinner.show(); }
        $("button:disabled").attr("title", "");

        const distributorId = this.dbs.find(el => el.name === this.service.currentOtherKp.distributorName)?.distributorId;
        const kamId = this.kams.find(el => el.name === this.service.currentOtherKp.kamName)?.kamId;
        const customerId = this.service.currentOtherKp.customerId
          ?? this.otherKp.customerId
          ?? this.customers.find(el => el.name === this.service.currentOtherKp.customerName)?.customerId;
        const regionId = this.regions.find(el => el.name === this.service.currentOtherKp.regionName)?.regionId;

        this.otherKp.iSReplaceCompetitors = this.isAuctionMode() ? 1 : 0;

        if (distributorId) {
          this.otherKp.distributorId = distributorId;
          this.service.currentOtherKp.distributorId = distributorId;
        }

        if (kamId) {
          this.otherKp.kamId = kamId;
          this.service.currentOtherKp.kamId = kamId;
        }

        if (customerId) {
          this.otherKp.customerId = customerId;
          this.service.currentOtherKp.customerId = customerId;
        }

        if (this.otherKp.customerName === 'Другое' || this.isAuctionMode()) {
          this.otherKp.customerId = null;
          this.otherKp.customerName = this.service.newCustomerName;
          this.otherKp.inn = this.service.newCustomerInn;
          this.service.currentOtherKp.customerId = null;
          this.service.currentOtherKp.customerName = this.service.newCustomerName;
          this.service.currentOtherKp.inn = this.service.newCustomerInn;
        }

        if (regionId) {
          this.otherKp.regionId = regionId;
          this.service.currentOtherKp.regionId = regionId;
        }

        const putXid = this._loggingService.generateUUID();
        const putQualName = 'App.Services.OtherKpDetailService.putOtherKp';

        try {
          this._loggingService.logStart(putXid, putQualName, inputParams, 'Put other KP');

          this.service.putOtherKp(this.otherKp).subscribe({
            next: (result) => {
              this.service.currentOtherKp = result;
              this.service.currentOtherKp.dateAuction = this.otherKp.dateAuction;
              this.service.viewKpNumber = result.id;
              this.service.isNew = false;
              this.service.otherKp.next({ ...this.service.currentOtherKp });

              if (this._spinner) { this._spinner.hide(); }
              this.service.triggerReload();
              this.service.notifyKpSaved();

              this._loggingService.logFinish(putXid, putQualName, inputParams, 'Other KP saved');

              if (!this.isContainFm && !this.isContainCd) {
                if (this.rejected) this.SendAdjustmentMail("rejected");
                else this.SendAdjustmentMail("confirmed");
              }
              this.updateStateMailIcon();

              $('#modalOtherKpDetail').modal('toggle');

              this._loggingService.logFinish(xid, qualName, inputParams, '[EventHandler] Сохранение и закрытие карточки пользовательского КП завершено');
            },
            error: (err) => {
              if (this._spinner) { this._spinner.hide(); }
              this._loggingService.logError(putXid, putQualName, err, inputParams, 'Failed to save other KP');
              this._loggingService.logError(xid, qualName, err, inputParams, 'Save and exit failed');
            }
          });
        } catch (error) {
          if (this._spinner) { this._spinner.hide(); }
          this._loggingService.logError(putXid, putQualName, error, inputParams, 'Put other KP method failed');
          this._loggingService.logError(xid, qualName, error, inputParams, 'Save and exit failed');
          throw error;
        }
      } else {
        this._loggingService.logFinish(xid, qualName, inputParams, 'Validation failed - saveAndExit skipped');
      }
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, 'onSaveAndExit failed');
      throw error;
    }
  }


  haveErrors(): boolean {
    let haveErrors = false
    this.errorHtmlContent.value = ''
    let regionId = this.regions.find(el => el.name === this.service.currentOtherKp.regionName)?.regionId

    const customerNameWithInn = [
      "Другое",
      "Множественные заказчики",
      "Закрытая площадка",
    ].includes(this.otherKp.customerName)
      ? this.otherKp.customerName
      : `${this.otherKp.inn} - ${this.otherKp.customerName}`;

    const customerId = this.service.currentOtherKp.customerId
      ?? this.otherKp.customerId
      ?? this.customers.find(el => el.name === customerNameWithInn)?.customerId;

    let kamId = this.kams.find(el => el.name === this.service.currentOtherKp.kamName)?.kamId
    let distributorId = this.dbs.find(el => el.name === this.service.currentOtherKp.distributorName)?.distributorId

    if (!regionId) {
      this.errorHtmlContent.value += '<br>Требуется выбрать регион'
      haveErrors = true
    }

    if (!customerId) {
      if (this.otherKp.customerName == 'Другое' || this.isReplaceCompetitorsView) {
        if (this.service.newCustomerName == "" || this.service.newCustomerInn == "") {
          this.errorHtmlContent.value += '<br>Требуется ввести данные нового заказчика'
          haveErrors = true
        }
      } else {
        this.errorHtmlContent.value += '<br>Требуется выбрать заказчика'
        haveErrors = true
      }
    }

    if (!kamId) {
      this.errorHtmlContent.value += '<br>Требуется выбрать КАМ'
      haveErrors = true
    }
    if (!distributorId) {
      this.errorHtmlContent.value += '<br>Требуется выбрать ДБ'
      haveErrors = true
    }
    if (this.service.currentOtherKp.nomenclatureList.length == 0) {
      this.errorHtmlContent.value += '<br>Требуется выбрать номенклатуру'
      haveErrors = true
    }

    if (this.service.currentOtherKp.nomenclatureList.length > 0) {
      for (let nomenclature of this.service.currentOtherKp.nomenclatureList) {
        if (nomenclature.count == null || nomenclature.priceKp == null || nomenclature.count <= 0 || nomenclature.priceKp <= 0) {
          this.errorHtmlContent.value += '<br>Требуется ввести количество и цену КП для выбранной номенклатуры'
          haveErrors = true
          break
        }
      }
    }

    return haveErrors
  }

  private updateStateMailIcon() {
    this.mailHistory();

    var isNeedAdjustment;
    const st = this.service.currentOtherKp.agreementStatus;
    if (st == "Согласовано" || st == "Не требует согласования") {
      isNeedAdjustment = false;
    } else {
      isNeedAdjustment = true;
    }

    const btn = document.getElementById('otherKpButtonMailSender1');
    if (btn) {
      if (this.service.currentOtherKp.distributorName != "" && this.service.currentOtherKp.distributorName != undefined && !isNeedAdjustment && !this.rejected && !(this.isAuctionMode() && !this.isSavedReplaceCompetitors)) {
        btn.classList.remove('text-danger');
        btn.classList.add('text-success');
        $('#otherKpButtonMailSender1').attr("disabled", false);
      } else {
        btn.classList.remove('text-success');
        btn.classList.add('text-danger');
        $('#otherKpButtonMailSender1').attr("disabled", true);
      }
    }
  }

  hideOutFromDevelop(isHide: boolean) {
    if (this.hideOutFromDevelopFilter != isHide) {
      this.hideOutFromDevelopFilter = isHide
    }
  }

  onSelectedStatus(statusKP) {
    this.service.currentOtherKp.statusKP = statusKP
  }

  onSelectedTypeKP(type: any) {
    const id = type.type_ID ?? type.typeId ?? null;
    this.otherKp.typeId = id;
    this.otherKp.typeName = type.typeName;
    this.service.currentOtherKp.typeId = id;
    this.service.currentOtherKp.typeName = type.typeName;
  }

  private findTypeName(typeId: any): string | null {
    if (typeId == null) return null;
    const t = this.types.find(x => x.typeId === typeId || x.type_ID === typeId || x.typeId == Number(typeId));
    return t ? t.typeName : null;
  }



  changeDetail(type: number, rowData: Nomenclature) {
    this.spinner.show();
    let nomenclature = this.service.currentOtherKp.nomenclatureList.find(el => el.goodId == rowData.goodId)
    switch (type) {
      case (1): { //nmc
        nomenclature.nmc = Number(rowData.nmc.toString().replace(',', '.'))
        break;
      }
      case (2): { //count
        nomenclature.count = Number(rowData.count.toString().replace(',', '.'))
        break;
      }
      case (3): { //priceKp
        nomenclature.priceKp = Number(rowData.priceKp.toString().replace(',', '.'))
        break;
      }
    }
    nomenclature.summKp = (nomenclature.priceKp ?? 0) * (nomenclature.count ?? 0)
    this.service.updateTempData(this.spinner)
    this.updateNeedAdjustmentState()
    this.updateStateMailIcon()
  }

  isShowSaiStatus() {
    if (this.isChiefRole || (this.service.currentOtherKp.statusKP != null &&
      this.service.currentOtherKp.statusKP != undefined &&
      this.service.currentOtherKp.statusKP.toLocaleLowerCase().indexOf("sai") >= 0)) {
      return true;
    } else {
      return false;
    }
  }

  isShowSaiStatusInvert() {
    if (this.isChiefRole) {
      return true;
    } else {
      if (this.service.currentOtherKp.statusKP != null && this.service.currentOtherKp.statusKP != undefined &&
        this.service.currentOtherKp.statusKP.toLocaleLowerCase().indexOf("sai") >= 0) {
        return false;
      }
      return true;
    }
  }

  onSetDistributor() {
    this.otherKp.distributerParticipantName = this.otherKp.distributorName
    this.updateStateMailIcon()
  }

  @ViewChild(ModalOtherKpMailSenderComponent)
  m: ModalOtherKpMailSenderComponent;

  mailToCommercialOffer(type: number) {
    if (this.m != undefined) {
      this.m.mailToCommercialOffer(this.service.currentOtherKp.id, + type, this.popupHtmlContent)
    }
  }

  @ViewChild(ModalOtherKpSendAdjustmentComponent)
  ModalSendAdjustment: ModalOtherKpSendAdjustmentComponent;

  sendAdjustment() {
    this.ModalSendAdjustment.cleannField();
  }

  isOtherKpNeedAdjustment() {
    this.updateNeedAdjustmentState();

    if (this.token.isCD()) {
      // if(this.isContainCd){
      //   return true;
      // }
      return false;
    }

    if (this.service.currentOtherKp.nomenclatureList) {

      if (this.token.isFM() && this.isContainFm && !this.isContainCd) {
        return false;
      }
      if (this.token.isFM() && this.isContainCd) {
        return true;
      }

      if (this.isContainFm || this.isContainCd) {
        return true;
      }

    }
    return false;
  }

  changeTemplate() {
    const btn = document.getElementById('otherKpButtonMailSender1');
    if (btn) {
      btn.classList.remove('text-success');
      btn.classList.add('text-danger');
      $('#otherKpButtonMailSender1').attr("disabled", true);
    }
    $("button:disabled").attr("title", "Необходимо сохранить изменения");
    this.updateNeedAdjustmentState();
  }

  setAdjustment(isAdjustment, rowData) {

    if (!rowData.status) return false;

    if (isAdjustment) {
      rowData.status = "Согласовано"
    } else {
      rowData.status = "Отклонено"
    }

    this.changeTemplate();
    this.isRowNeedAdjustment(rowData);
  }


  // Проверка необходимости согласования
  isRowNeedAdjustment(rowData) {
    if (rowData.status == null || rowData.status == "") return false;

    const st = rowData.status.toLocaleLowerCase();

    if (this.token.isFM() && (st == "согласование с фм")) {
      return true;
    } else if (this.token.isCD() && (st == "согласование с кд" || st == "согласование с фм")) {
      return true;
    }

    return false;
  }

  onInnInput(e: Event) {
    const input = e.target as HTMLInputElement;
    const cleaned = input.value.replace(/\D+/g, '');
    if (cleaned !== input.value) input.value = cleaned;
    this.service.newCustomerInn = cleaned;
  }

  onInnPaste(e: ClipboardEvent) {
    e.preventDefault();
    const paste = e.clipboardData?.getData('text') ?? '';
    const onlyDigits = paste.replace(/\D+/g, '');
    const input = e.target as HTMLInputElement;

    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const before = input.value.slice(0, start);
    const after = input.value.slice(end);

    const newValue = (before + onlyDigits + after).replace(/\D+/g, '');
    input.value = newValue;
    this.service.newCustomerInn = newValue;

    const caretPos = before.length + onlyDigits.length;
    setTimeout(() => input.setSelectionRange(caretPos, caretPos), 0);
  }


  updateNeedAdjustmentState() {
    this.isContainCd = false;
    this.isContainFm = false;
    this.rejected = false;

    if (this.service.currentOtherKp.nomenclatureList) {
      for (let index = 0; index < this.service.currentOtherKp.nomenclatureList.length; index++) {
        const element = this.service.currentOtherKp.nomenclatureList[index];
        if (element.status == null || element.status == "") return
        const st = element.status.toLowerCase();

        if (st == "согласование с кд") {
          this.isContainCd = true;
        }

        if (st == "согласование с фм") {
          this.isContainFm = true;
        }

        if (st == "отклонено") {
          this.rejected = true;
        }
      }
    }
  }

  isAuctionMode(): boolean {
    return this.service.auctionMode;
  }

  // Видимость и блокировка полей в режиме «Замена конкурентов» — по статусу КП
  get isReplaceCompetitorsView(): boolean {
    return this.otherKp?.typeId === 2 || this.isAuctionMode();
  }

  onApplyToAuction(): void {
    const xid = this._loggingService.generateUUID();
    const qualName = `${MODULE_PATH}.OtherKpMainModalDetailComponent.onApplyToAuction`;

    try {
      this._loggingService.logStart(xid, qualName, null, 'Applying KP to auction');

      this.service.applyKpToAuction();
      $('#modalOtherKpDetail').modal('hide');

      this._loggingService.logFinish(xid, qualName, null, 'KP applied to auction, modal closed');
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, null, 'Failed to apply KP to auction');
      throw error;
    }
  }

  onCancelAuctionMode(): void {
    this.service.notifyKpSaved();
    this.service.resetAuctionMode();
    $('#modalOtherKpDetail').modal('hide');
  }

  SendAdjustmentMail(key) {
    switch (key) {
      case "confirm":
        // Отправка писем на согласование
        if (this.service.currentOtherKp.id != null) {
          this.http.get<Array<string>>(apiServer + "/otherKp/SendMailToConfirm/" + this.service.currentOtherKp.id)
            .subscribe(resp => {
            });
        }
        break;
      case "rejected":
        // Отправка писем отклнонено
        if (this.service.currentOtherKp.id != null) {
          this.http.get<Array<string>>(apiServer + "/otherKp/SendMailToRejected/" + this.service.currentOtherKp.id)
            .subscribe(resp => {
            });
        }
        break;
      case "confirmed":
        // Отправка писем согласовано
        if (this.service.currentOtherKp.id != null) {
          this.http.get<Array<string>>(apiServer + "/otherKp/SendMailToConfirmed/" + this.service.currentOtherKp.id)
            .subscribe(resp => {
            });
        }
        break;

      default:
        break;
    }
  }
}

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-detail/other-kp-modal-detail.component.ts